export default class Country {
    id: string = null!;
    name: string = null!;
    abbreviation: string = null!;
}

export class ExtendedCountry {
    id: string = null!;
    name: string = null!;
    abbreviation: string = null!;
    fullName: string = "";

    constructor(country: Country) {
        this.id = country.id;
        this.name = country.name;
        this.abbreviation = country.abbreviation;
        this.fullName = this.name + " - " + this.abbreviation;
    }
}
